<template>
  <img
    src="~/assets/icon/icon-cart.svg"
    alt=""
  />
</template>
